import { HomeSliceType, VideoHeroSlice } from '../../../../types/slice';
import { toText } from '../../fields';
import { LinkWeb, toLink } from '../../fields/link';

const videoHeroSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): VideoHeroSlice | undefined => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }
  const videoLink = toLink(data.primary?.video) as LinkWeb;
  if (!videoLink) {
    return undefined;
  }

  return {
    type: HomeSliceType.VIDEO_HERO,
    title: toText(data.primary?.title),
    description: toText(data.primary?.description),
    videoLink: videoLink,
    videoType: data.primary?.videoType,
    ctaLabel: toText(data.primary?.ctaLabel),
    ctaLink: toLink(data.primary?.ctaLink),
    ctaTranscriptionLabel: toText(data.primary?.ctaTranscriptionLabel),
    ctaTranscriptionLink: toLink(data.primary?.ctaTranscriptionLink),
  };
};

export default videoHeroSlice;
